import { requestState, baseUrl } from "./utils";
import axios from "axios";
import { showError } from "./error";

export const SET_PREVIEW_MATCHES_STATE = "SET_PREVIEW_MATCHES_STATE";
export const SET_PREVIEW_MATCHES = "SET_PREVIEW_MATCHES";

export function setPreviewMatchesState(state) {
    return {
        type: SET_PREVIEW_MATCHES_STATE,
        state: state,
    };
}

export function setPreviewMatches(matches) {
    return {
        type: SET_PREVIEW_MATCHES,
        matches: matches,
    };
}

export function loadPreviewMatches(properties) {
    return async (dispatch) => {
        dispatch(setPreviewMatchesState(requestState.inProgress));
        try {
            const res = await axios.post(
                `${baseUrl}/matchmaking/preview`,
                properties
            );
            console.log("POST /matchmaking/preview response:", res); // DEBUG

            const matches = [...res.data];
            dispatch(setPreviewMatchesState(requestState.ok));
            dispatch(setPreviewMatches(matches.filter(m => m))); // Filters out null matches
            return res;
        } catch (e) {
            dispatch(setPreviewMatchesState(requestState.fail));
            if (e.response && e.response.data && e.response.data.message) {
                dispatch(showError(e.response.data.message));
            } else {
                dispatch(showError("Failed to fetch matches"));
            }
        }
    };
}
